/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../components/basic/Link';
import { AnchorWrapper } from './Styled';

class Anchor extends React.Component {
  render() {
    const { href, children, prefetch } = this.props;
    if (href) {
      return (
        <Link href={href} prefetch={prefetch}>
          <AnchorWrapper {...this.props}>{children}</AnchorWrapper>
        </Link>
      );
    }
    return <AnchorWrapper {...this.props}>{children}</AnchorWrapper>;
  }
}

Anchor.propTypes = {
  href: PropTypes.string,
  color: PropTypes.string,
  prefetch: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

Anchor.defaultProps = {
  color: null,
  prefetch: false
};

export default Anchor;
